import currency from "./currency.socket";
import product from "./product.socket";

export default function ({ app }, inject) {
  const actions = { currency, product };
  inject("socket", actions);
}
